import { inject, Injectable, signal } from "@angular/core";
import { LocalStorageService } from "../../../shared/services/local-storage.service";
import { SnackService } from "../../../shared/services/snack-service.service";
import { User } from "../../auth/models/user.model";

@Injectable({
  providedIn: "root",
})
export class TicketService {
  localStorageService = inject(LocalStorageService);
  snackService = inject(SnackService);
  recording = signal(false);
  tracker: any;

  private scriptLoaded = false;
  private readonly widgetUrl =
    "https://embed.tawk.to/684d9221a3ad3e1910ba1125/1itng5le1";

  constructor() {}

  load(name?: string, email?: string): void {
    return;
    // Supprime l'ancien script s'il existe
    const existingScript = document.querySelector(
      'script[src^="https://embed.tawk.to"]',
    );
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    // Réinitialise les variables globales
    delete (window as any).Tawk_API;
    delete (window as any).Tawk_LoadStart;
    this.scriptLoaded = false;

    // Initialise l'API avec les infos visiteur et callbacks
    (window as any).Tawk_API = {
      visitor: { name, email },
      onChatMessageAgent: (message) => {
        if (message?.message?.startsWith("#record")) {
          this.startRecording();
        }
        if (message?.message?.startsWith("#stoprecord")) {
          this.stopRecording();
        }
      },
      onLoad: () => {
        // (window as any).Tawk_API?.hideWidget();
      },
    };

    // Charge le widget Tawk.to
    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = this.widgetUrl;
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    const s0 = document.getElementsByTagName("script")[0];
    s0?.parentNode?.insertBefore(s1, s0);

    s1.onload = () => {
      this.scriptLoaded = true;
    };
  }

  maximize(): void {
    (window as any).Tawk_API?.maximize?.();
  }

  minimize(): void {
    (window as any).Tawk_API?.minimize?.();
  }

  toggle(): void {
    (window as any).Tawk_API?.toggle?.();
  }

  async startRecording() {
    if (!this.tracker) {
      this.snackService.error("Erreur d'enregistrement de session");
      return;
    }
    this.snackService.info("Enregistrement de session activé");

    this.recording.set(true);
    this.localStorageService.putWithTTL("recording", true);
    await this.tracker.start();
    const session = this.tracker.getSessionURL();
    if (session) {
      (window as any).Tawk_API.addEvent(
        "Recording-session",
        {
          session,
        },
        function (error) {
          if (error) {
          }
        },
      );
      // (window as any).Tawk_API?.addTags?.([session], (error: any) => {
      //   if (error) {
      //     console.error("Tawk tag error:", error);
      //   }
      // });
    }
  }

  stopRecording() {
    if (!this.tracker) {
      this.snackService.error("Erreur d'enregistrement de session");
      return;
    }
    this.snackService.info("Enregistrement de session desactivé");
    const session = this.tracker.getSessionURL();
    (window as any).Tawk_API.addEvent(
      "Stop-recording-session",
      {
        session,
      },
      function (error) {
        if (error) {
        }
      },
    );
    this.tracker.stop();
    this.recording.set(false);
    this.localStorageService.putWithTTL("recording", false);
  }

  async initTracker(user: User) {
    if (!this.tracker) {
      const t = await import("@openreplay/tracker");
      t.tracker.configure({
        projectKey: "iiIZKmbd7h95MN43WNHt",
        capturePerformance: true,
        __DISABLE_SECURE_MODE: true,
      });
      this.tracker = t.tracker;
    }
    this.tracker.setUserID(user.email ?? user.username);
    this.tracker.setMetadata("email", user.email);
    this.tracker.setMetadata("username", user.username);
    this.tracker.setMetadata("domain", window.location.hostname);
  }
}
